import { Filter } from 'CommonData/poco/index';

export class ProductModel { 
    public name: string;
    public modelUrl: string;
    public swatchUrl: string;
    public filters: Array<Filter>;
    public categoryType: string;

    constructor({ name, modelUrl, swatchUrl, filters, categoryType } : { name: string, modelUrl: string, swatchUrl: string, filters?: Array<Filter>, categoryType?: string }) {
        this.name = name;
        this.modelUrl = modelUrl;
        this.swatchUrl = swatchUrl;
        this.filters = filters;
        this.categoryType = categoryType;
    }
}